import { render, staticRenderFns } from "./MonthlyTotalCard.vue?vue&type=template&id=6941b740&scoped=true&"
import script from "./MonthlyTotalCard.vue?vue&type=script&lang=js&"
export * from "./MonthlyTotalCard.vue?vue&type=script&lang=js&"
import style0 from "./MonthlyTotalCard.vue?vue&type=style&index=0&id=6941b740&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6941b740",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VRow})
